import { ExperienceMode } from '@/stores/experience-store';
import { Icons } from '@usepepper/sprout-kit-ui';
import {
  MicroProduct,
  MicroProductsSlot,
  useMicroProductsLoader,
} from '@domain/microproducts/loaders/use-microproducts-loader';
import { NavItemIcon } from '@/domain/navigation/types';

const EXPERIENCE_MODE_BY_PRODUCT_ID: Record<string, ExperienceMode> = {
  'finance-hub': ExperienceMode.FINANCE_HUB,
};

export interface ExperienceSwitcherProduct {
  icon?: NavItemIcon;
  label: string;
  mobileEnabled: boolean;
  mode: ExperienceMode;
}

interface UseExperienceSwitcherProductsLoaderResult {
  error: Error | null;
  loading: boolean;
  products: ExperienceSwitcherProduct[];
}

const resolveIcon = (product: MicroProduct): NavItemIcon | undefined => {
  if (!product.displayIconName) {
    return undefined;
  }
  const icons = Icons as Record<string, NavItemIcon | undefined>;
  return icons[product.displayIconName];
};

export const useExperienceSwitcherProductsLoader =
  (): UseExperienceSwitcherProductsLoaderResult => {
    const { slots, loading, error } = useMicroProductsLoader();

    const switcherSlot = slots.find(
      (s) => s.slot === MicroProductsSlot.EXPERIENCE_SWITCHER,
    );

    const products = (switcherSlot?.products ?? []).reduce<
      ExperienceSwitcherProduct[]
    >((resolved, product) => {
      const mode = EXPERIENCE_MODE_BY_PRODUCT_ID[product.id];
      if (mode) {
        resolved.push({
          icon: resolveIcon(product),
          label: product.displayName,
          mobileEnabled: product.props.mobile_enabled === true,
          mode,
        });
      }
      return resolved;
    }, []);

    return {
      error: error ?? null,
      loading,
      products,
    };
  };
